import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.17.0_@_45791bdf648e034943cc83377a5308c0/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}